<template>
  <div
    class="care-plus-dashboard-section-summary"
    :style="{
      'justify-content': taskCompletionLevel > 0 ? 'space-between' : 'flex-end'
    }"
  >
    <div v-if="taskCompletionLevel > 0 && totalPadCycles >= requiredPadCycles">
      <div>{{ $t('text.responsiveness') }}</div>
    </div>
    <div
      class="time-bar-container ml-60"
      v-if="totalPadCycles >= requiredPadCycles"
    >
      <div class="time-bar">
        <div class="time-bar-item green-bg"></div>
        <div class="time-bar-item yellow-bg"></div>
        <div class="time-bar-item red-bg"></div>
      </div>
      <div
        class="red-font"
        style="position: absolute; right: 0;"
        v-if="taskCompletionLevel >= 67"
      >
        {{ $t('text.too_late') }}
      </div>
      <div
        class="time-bar-pointer"
        :style="{
          left: `calc(${taskCompletionLevel}% - 10px)`,
          '--timebar-pointer-color':
            taskCompletionLevel < 34
              ? '#ADCD85'
              : taskCompletionLevel < 67
              ? '#FFBF00'
              : '#F1A0AA'
        }"
        v-if="taskCompletionLevel > 0"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    requiredPadCycles: {
      require: true,
      type: Number
    },
    totalPadCycles: {
      require: true,
      type: Number
    },
    taskCompletionLevel: {
      require: true,
      type: Number // 0 ~ 100
    }
  }
}
</script>

<style lang="scss" scoped></style>
